import { c as _c } from "react/compiler-runtime";
import React from 'react';
export const ProNotAuthorisedIcon = props => {
  const $ = _c(15);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Pro not authorized icon</title>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t10;
  let t11;
  let t12;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <g opacity=".9" fill="#f3f4f6"><path opacity=".9" d="M216.942 123.942h-41.166v13.978h41.166v-13.978zm-44.859 0h-41.166v13.978h41.166v-13.978zm-44.859 0H86.059v13.978h41.165v-13.978zm-44.846 0H41.212v13.978h41.166v-13.978zM216.942 90.58h-41.166v13.978h41.166V90.58zm-44.859 0h-41.166v13.978h41.166V90.58zm-44.859 0H86.059v13.978h41.165V90.58zm-44.846 0H41.212v13.978h41.166V90.58zm89.705-33.349h-41.166v13.978h41.166V57.231zm-44.859 0H86.059v13.978h41.165V57.231zm5.324-36.985l-2.568 13.742 40.472 7.499 2.567-13.742-40.471-7.499zm-5.324 3.623H86.059v13.978h41.165V23.869zm67.282 83.392h-41.165v13.978h41.165v-13.978zm-44.846 0h-41.166v13.978h41.166v-13.978zm-44.859 0H63.635v13.978h41.166v-13.978zm-44.556 0H19.08v13.978h41.166v-13.978zM194.506 73.9h-41.165v13.978h41.165V73.9zm-44.846 0h-41.166v13.978h41.166V73.9zm-44.859 0H63.635v13.978h41.166V73.9zm44.859-33.35h-41.166v13.978h41.166V40.55zm-44.859 0H63.635v13.978h41.166V40.55z" /><path opacity=".9" d="M149.437 7l-41.166 3.69 1.263 13.978 41.166-3.689L149.437 7z" /></g>;
    t2 = <path fill="#9ca3af" d="M73.305 68.001h9.038v82h-9.038z" />;
    t3 = <path opacity=".08" fill="#000" d="M80.335 68.001h2.008v82h-2.008z" />;
    t4 = <path fill="#9ca3af" d="M158.661 68.001h9.038v82h-9.038z" />;
    t5 = <path opacity=".08" fill="#000" d="M165.69 68.001h2.008v82h-2.008z" />;
    t6 = <path d="M180.752 108.001H60.251v18h120.501v-18z" fill="#e5e7eb" />;
    t7 = <path d="M118.269 108.001l-20.587 18H82.871l20.586-18h14.812zm-29.1 0l-20.587 18h-8.331v-5.667l14.107-12.333h14.811zm43.346 0l-20.587 18h14.811l20.587-18h-14.811zm43.87 0l-20.586 18h-14.812l20.587-18h14.811zm4.368 8.635v9.36h-10.706l10.706-9.36z" fill="#22C55E" />;
    t8 = <path opacity=".08" fill="#000" d="M60.251 124.001h120.501v2H60.251z" />;
    t9 = <path d="M180.752 78.001H60.251v17.998h120.501V78.001z" fill="#e5e7eb" />;
    t10 = <path d="M118.269 78.001l-20.587 18H82.871l20.586-18h14.812zm-29.1 0l-20.587 18h-8.331v-5.666l14.107-12.334h14.811zm43.346 0l-20.587 18h14.811l20.587-18h-14.811zm43.87 0l-20.586 18h-14.812l20.587-18h14.811zm4.368 8.637V96h-10.706l10.706-9.362z" fill="#22C55E" />;
    t11 = <path opacity=".08" fill="#000" d="M60.251 94.001h120.501v2H60.251z" />;
    t12 = <path fillRule="evenodd" d="M110.46 30.333a2 2 0 0 0-1.713.968l-5.021 8.333a2 2 0 0 0 .226 2.369l14.226 15.833.062.066c.295.301.648.539 1.036.701a3.18 3.18 0 0 0 1.226.246c.421 0 .838-.084 1.226-.246a3.18 3.18 0 0 0 1.037-.701l.062-.066 14.226-15.833a2 2 0 0 0 .225-2.369l-5.021-8.333a2 2 0 0 0-1.713-.968H110.46zm-2.544 10.098l3.674-6.098h17.824l3.674 6.098-12.586 14.008-12.586-14.008zm8.609-.732a2 2 0 1 0-3.426-2.064l-1.005 1.667c-.456.758-.36 1.727.236 2.381l3.348 3.667a2 2 0 0 0 2.954-2.697l-2.341-2.564.234-.388z" fill="#22C55E" />;
    $[1] = t1;
    $[2] = t10;
    $[3] = t11;
    $[4] = t12;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t1 = $[1];
    t10 = $[2];
    t11 = $[3];
    t12 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
    t9 = $[12];
  }
  let t13;
  if ($[13] !== props) {
    t13 = <svg xmlns="http://www.w3.org/2000/svg" width="240" height="160" viewBox="0 0 240 160" fill="none" {...props}>{t0}{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}</svg>;
    $[13] = props;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  return t13;
};